import React from 'react';
import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import { injectIntl } from 'react-intl';
import { discHint, discTag } from '../../constants/disc';

const ButtonStyle = {
  minHeight: 27,
  minWidth: 27,
  borderRadius: 3,
  padding: 4,
  boxShadow: 'none',
  margin: '0 2px',
  lineHeight: 1
};

const DISCButton = props => {
  const { selected, color, style, ...rest } = props;

  return (
    <Button
      variant="contained"
      style={{
        ...ButtonStyle,
        background: selected ? color : '#ccc',
        color: selected ? '#fff' : '#000',
        ...style
      }}
      {...rest}
    />
  );
};

const DISCSelect = props => {
  const { intl, personality, onChange } = props;

  const createOnClickHandler = value => () => onChange(personality === value ? '' : value);

  return (
    <Grid container sx={{
      alignItems: "center"
    }}>
      <Grid>
        <DISCButton selected={personality === 'D'} color="#EA8462" title={discTag('D', intl.locale)} onClick={createOnClickHandler('D')}>
          {intl.formatMessage({ id: 'personality_D' })}
        </DISCButton>
      </Grid>
      <Grid>
        <DISCButton selected={personality === 'I'} color="#EAC862" title={discTag('I', intl.locale)} onClick={createOnClickHandler('I')}>
          {intl.formatMessage({ id: 'personality_I' })}
        </DISCButton>
      </Grid>
      <Grid>
        <DISCButton selected={personality === 'S'} color="#62EA84" title={discTag('S', intl.locale)} onClick={createOnClickHandler('S')}>
          {intl.formatMessage({ id: 'personality_S' })}
        </DISCButton>
      </Grid>
      <Grid>
        <DISCButton selected={personality === 'C'} color="#62A6EA" title={discTag('C', intl.locale)} onClick={createOnClickHandler('C')}>
          {intl.formatMessage({ id: 'personality_C' })}
        </DISCButton>
      </Grid>
      {discTag(personality, intl.locale) && (
        <Grid style={{ marginLeft: 8, fontSize: 13, color: '#475569' }}>
          {discTag(personality, intl.locale)} · {discHint(personality, intl.locale)}
        </Grid>
      )}
    </Grid>
  );
};

export default injectIntl(DISCSelect);
